module.exports = __webpack_public_path__ + "img/patient.9a4a6be9.svg";